import { createContext } from "react";

export const AdPlanContext = createContext({
  parentPlan: {},
  childPlan: {},
  savedChildPlans: /** @type {any[] | null} */ (null),
  setSavedChildPlans: /** @type {(v: any) => void} */ (() => {}),
  setRefetchOnUpdate: /** @type {(v: boolean) => void} */ (() => {}),
  resetAdPlanContext: () => {},
});
